import { render, staticRenderFns } from "./App.vue?vue&type=template&id=43395154&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./App.vue?vue&type=style&index=0&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "d5654d2a"
  
)

component.options.__file = "App.vue"
export default component.exports